import { render, staticRenderFns } from "./ProductContent.vue?vue&type=template&id=23fa86e4&scoped=true&"
import script from "./ProductContent.vue?vue&type=script&lang=ts&"
export * from "./ProductContent.vue?vue&type=script&lang=ts&"
import style0 from "./ProductContent.vue?vue&type=style&index=0&id=23fa86e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fa86e4",
  null
  
)

export default component.exports